<div class="page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>{{ ad?.title_en || ad?.title_ar || 'Ad Detail' }}</h1>
        <p>{{ ad?.name_en || ad?.name_ar }}</p>
      </div>
    </div>
    <div class="header-actions" *ngIf="ad && !isEditMode">
      <button class="btn-secondary" (click)="enableEdit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
        Edit
      </button>
      <button class="btn-danger" (click)="confirmDelete()">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
        Delete
      </button>
  </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading ad...</p>
  </div>

  <ng-container *ngIf="!isLoading && ad">

    <!-- Success Toast -->
    <div class="toast-success" *ngIf="successMessage">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      {{ successMessage }}
    </div>

    <!-- ── VIEW MODE ── -->
    <div *ngIf="!isEditMode">
      <div class="detail-card">

        <div class="detail-section">
          <h2 class="section-title">Ad Info</h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Title (English)</span>
              <span class="info-value">{{ ad.title_en || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Title (Arabic)</span>
              <span class="info-value" dir="rtl">{{ ad.title_ar || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Name (English)</span>
              <span class="info-value">{{ ad.name_en || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Name (Arabic)</span>
              <span class="info-value" dir="rtl">{{ ad.name_ar || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Phone Number</span>
              <span class="info-value">{{ ad.phone_number || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">WhatsApp Number</span>
              <span class="info-value">{{ ad.whatsapp_number || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Status</span>
              <span class="badge" [class.badge-active]="ad.is_active" [class.badge-inactive]="!ad.is_active">
                {{ ad.is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>
        </div>

        <div class="detail-divider"></div>

        <div class="detail-section">
          <h2 class="section-title">Description</h2>
          <div class="bilingual-desc" *ngIf="ad.description_en || ad.description_ar">
            <div *ngIf="ad.description_en">
              <span class="desc-lang-label">EN</span>
              <p class="ad-description">{{ ad.description_en }}</p>
            </div>
            <div *ngIf="ad.description_ar">
              <span class="desc-lang-label">AR</span>
              <p class="ad-description" dir="rtl">{{ ad.description_ar }}</p>
            </div>
          </div>
          <p class="ad-description" *ngIf="!ad.description_en && !ad.description_ar">—</p>
        </div>

        <div class="detail-divider"></div>

        <div class="detail-section">
          <h2 class="section-title">Images</h2>
          <div class="media-gallery" *ngIf="ad.images && ad.images.length > 0">
            <div class="gallery-item" *ngFor="let url of ad.images; let i = index">
              <div class="gallery-thumb">
                <img [src]="url" [alt]="'image-' + i" class="thumb-media" />
              </div>
              <div class="gallery-meta">
                <span class="media-type-badge">Image</span>
                <span class="media-url-text" [title]="url">{{ url }}</span>
              </div>
            </div>
          </div>
          <p class="no-media" *ngIf="!ad.images || ad.images.length === 0">No images attached.</p>
        </div>

      </div>
    </div>

    <!-- ── EDIT MODE ── -->
    <div *ngIf="isEditMode">
      <div class="error-msg" *ngIf="errorMessage">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ errorMessage }}
      </div>

      <form class="form-card" (ngSubmit)="saveEdit()">

        <div class="form-section">
          <h2 class="section-title">Edit Ad Info</h2>

          <!-- Title — bilingual block -->
          <div class="bilingual-block">
            <div class="bilingual-inputs">
              <div class="form-group">
                <label>Title (Arabic)</label>
                <input type="text" [(ngModel)]="editForm.title_ar" name="title_ar"
                  placeholder="عنوان الإعلان بالعربية..." dir="rtl" />
              </div>
              <div class="form-group">
                <label>Title (English) <span class="required">*</span></label>
                <input type="text" [(ngModel)]="editForm.title_en" name="title_en"
                  placeholder="Ad title in English..." />
              </div>
            </div>
            <div class="translate-strip">
              <button type="button" class="btn-translate"
                (click)="translateTitleToAr()"
                [disabled]="translating.titleToAr || !editForm.title_en?.trim()">
                <span *ngIf="!translating.titleToAr">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                  EN → AR
                </span>
                <span *ngIf="translating.titleToAr" class="spinner-xs"></span>
              </button>
              <span class="translate-divider">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16"/>
                </svg>
                Auto-translate
              </span>
              <button type="button" class="btn-translate"
                (click)="translateTitleToEn()"
                [disabled]="translating.titleToEn || !editForm.title_ar?.trim()">
                <span *ngIf="!translating.titleToEn">
                  AR → EN
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </span>
                <span *ngIf="translating.titleToEn" class="spinner-xs"></span>
              </button>
            </div>
            <div class="translate-error" *ngIf="translateErrors.titleToEn || translateErrors.titleToAr">
              Translation failed — please try again.
            </div>
          </div>

          <!-- Name — bilingual block -->
          <div class="bilingual-block">
            <div class="bilingual-inputs">
              <div class="form-group">
                <label>Name / Company (Arabic)</label>
                <input type="text" [(ngModel)]="editForm.name_ar" name="name_ar"
                  placeholder="اسم الشركة أو المعلن بالعربية..." dir="rtl" />
              </div>
              <div class="form-group">
                <label>Name / Company (English) <span class="required">*</span></label>
                <input type="text" [(ngModel)]="editForm.name_en" name="name_en"
                  placeholder="Company or advertiser name..." />
              </div>
            </div>
            <div class="translate-strip">
              <button type="button" class="btn-translate"
                (click)="translateNameToAr()"
                [disabled]="translating.nameToAr || !editForm.name_en?.trim()">
                <span *ngIf="!translating.nameToAr">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                  EN → AR
                </span>
                <span *ngIf="translating.nameToAr" class="spinner-xs"></span>
              </button>
              <span class="translate-divider">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16"/>
                </svg>
                Auto-translate
              </span>
              <button type="button" class="btn-translate"
                (click)="translateNameToEn()"
                [disabled]="translating.nameToEn || !editForm.name_ar?.trim()">
                <span *ngIf="!translating.nameToEn">
                  AR → EN
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </span>
                <span *ngIf="translating.nameToEn" class="spinner-xs"></span>
              </button>
            </div>
            <div class="translate-error" *ngIf="translateErrors.nameToEn || translateErrors.nameToAr">
              Translation failed — please try again.
            </div>
          </div>

          <!-- Description — bilingual block -->
          <div class="bilingual-block">
            <div class="bilingual-inputs">
              <div class="form-group">
                <label>Description (Arabic)</label>
                <textarea [(ngModel)]="editForm.description_ar" name="description_ar" rows="5"
                  placeholder="وصف الإعلان بالعربية..." dir="rtl"></textarea>
              </div>
              <div class="form-group">
                <label>Description (English)</label>
                <textarea [(ngModel)]="editForm.description_en" name="description_en" rows="5"
                  placeholder="Ad description in English..."></textarea>
              </div>
            </div>
            <div class="translate-strip">
              <button type="button" class="btn-translate"
                (click)="translateDescToAr()"
                [disabled]="translating.descToAr || !editForm.description_en?.trim()">
                <span *ngIf="!translating.descToAr">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                  EN → AR
                </span>
                <span *ngIf="translating.descToAr" class="spinner-xs"></span>
              </button>
              <span class="translate-divider">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16"/>
                </svg>
                Auto-translate
              </span>
              <button type="button" class="btn-translate"
                (click)="translateDescToEn()"
                [disabled]="translating.descToEn || !editForm.description_ar?.trim()">
                <span *ngIf="!translating.descToEn">
                  AR → EN
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </span>
                <span *ngIf="translating.descToEn" class="spinner-xs"></span>
              </button>
            </div>
            <div class="translate-error" *ngIf="translateErrors.descToEn || translateErrors.descToAr">
              Translation failed — please try again.
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Phone Number</label>
              <input type="text" [(ngModel)]="editForm.phone_number" name="phone_number" placeholder="+201000000100" />
            </div>
            <div class="form-group">
              <label>WhatsApp Number</label>
              <input type="text" [(ngModel)]="editForm.whatsapp_number" name="whatsapp_number" placeholder="+201000000100" />
            </div>
            <div class="form-group check-group">
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="editForm.is_active" name="is_active" />
                <span>Active</span>
              </label>
            </div>
          </div>
        </div>

        <div class="form-divider"></div>

        <div class="form-section">
          <h2 class="section-title">Images</h2>
          <p class="section-desc">Add image URLs. Press Enter or click Add.</p>

          <div class="media-input-row">
            <input type="text" [(ngModel)]="imageInput" name="imageInput"
              placeholder="https://example.com/image.jpg"
              (keydown)="onImageKeydown($event)" class="media-input" />
            <button type="button" class="btn-add" (click)="addImage()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              Add
            </button>
          </div>

          <div class="media-list" *ngIf="editForm.images.length > 0">
            <div class="media-item" *ngFor="let url of editForm.images; let i = index">
              <div class="media-thumb">
                <img [src]="url" class="thumb" [alt]="'image-' + i" />
              </div>
              <span class="media-url" [title]="url">{{ url }}</span>
              <span class="media-type">Image</span>
              <button type="button" class="btn-remove" (click)="removeImage(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
          <p class="empty-hint" *ngIf="editForm.images.length === 0">No images added yet.</p>
        </div>

        <div class="form-divider"></div>

        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="cancelEdit()">Cancel</button>
          <button type="submit" class="btn-primary" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Save Changes</span>
            <span *ngIf="isSubmitting" class="spinner-sm"></span>
          </button>
        </div>

      </form>
    </div>

  </ng-container>

  <!-- ── Delete Confirmation Modal ── -->
  <div class="modal-overlay" *ngIf="showDeleteModal">
    <div class="modal-confirm">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
      </div>
      <h3>Delete Ad</h3>
      <p>Are you sure you want to delete <strong>{{ ad?.title_en || ad?.title_ar }}</strong>? This action cannot be undone.</p>
      <div class="modal-btns">
        <button class="btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button class="btn-danger-solid" (click)="deleteAd()" [disabled]="isDeleting">
          <span *ngIf="!isDeleting">Yes, Delete</span>
          <span *ngIf="isDeleting" class="spinner-sm"></span>
        </button>
      </div>
    </div>
  </div>

</div>
